module.exports = __webpack_public_path__ + "img/-LV57MXTWTKy2v1NZFQQ.b3de0bed.jpg";